import React, { useEffect, useState } from 'react';
import './ZapLoader.css';

// Branded bootstrap loader — shown ONCE per browser session, on genuine
// application startup only (see App.js: gated by a sessionStorage flag so
// client-side route changes / API refetches never trigger it again). This
// is deliberately not used for per-request loading — that's what
// Skeleton/inline spinners are for.
//
// Held for a minimum of ~800ms so it reads as an intentional brand moment
// rather than a flash, but never longer than ~1.5s even if the caller is
// slow to mark the app ready — a premium loader should feel fast, not like
// an intro video.
const MIN_MS = 800;
const MAX_MS = 1500;

const ZapLoader = ({ ready, onDone }) => {
  const [visible, setVisible] = useState(true);
  const [exiting, setExiting] = useState(false);

  useEffect(() => {
    const mountedAt = performance.now();
    let exitTimer;

    const startExit = () => {
      setExiting(true);
      exitTimer = setTimeout(() => { setVisible(false); onDone?.(); }, 260);
    };

    const elapsed = () => performance.now() - mountedAt;
    const hardCap = setTimeout(startExit, MAX_MS);

    if (ready) {
      const remaining = Math.max(0, MIN_MS - elapsed());
      const t = setTimeout(startExit, remaining);
      return () => { clearTimeout(t); clearTimeout(hardCap); clearTimeout(exitTimer); };
    }
    return () => { clearTimeout(hardCap); clearTimeout(exitTimer); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ready]);

  if (!visible) return null;

  return (
    <div className={`zap-loader ${exiting ? 'zap-loader--exit' : ''}`} role="status" aria-label="Loading Zaptude">
      <svg className="zap-loader-bolt" width="52" height="52" viewBox="0 0 24 24" fill="none">
        <path d="M13 2 L4 14 H11 L10 22 L20 9 H13 L13 2 Z" fill="url(#zap-grad)" />
        <defs>
          <linearGradient id="zap-grad" x1="4" y1="2" x2="20" y2="22" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor="#6d28d9" />
            <stop offset="60%" stopColor="#4f46e5" />
            <stop offset="100%" stopColor="#0891b2" />
          </linearGradient>
        </defs>
      </svg>
      <span className="zap-loader-word">Zaptude</span>
    </div>
  );
};

export default ZapLoader;
